import { EmployeeDTO } from '@/common/integrations/menhir/employee/employee/employee.dto';
import { transformEstablishment } from '@/common/integrations/menhir/employee/establishments/establishments.dto';
import {
  IVoucher,
  IVoucherBalance,
} from '@/common/integrations/menhir/employee/vouchers/vouchers.types';
import { IMenhirVoucher, IMenhirVoucherBalance } from './vouchers.types';

export const transformVoucher = (menhirVoucher: IMenhirVoucher): IVoucher => {
  return {
    id: menhirVoucher.id,
    amount: menhirVoucher.amount,
    employeeId: menhirVoucher.employee_id,
    establishment: transformEstablishment(menhirVoucher.establishment),
    familyMember: menhirVoucher.family_member
      ? EmployeeDTO.transformFamilyMember(menhirVoucher.family_member)
      : undefined,
    reference: menhirVoucher.reference,
    expiredAt: menhirVoucher.expired_at,
    paidAt: menhirVoucher.paid_at,
    issuedAt: menhirVoucher.issued_at,
    beneficiary: {
      id: menhirVoucher.beneficiary.id,
      type: menhirVoucher.beneficiary.type,
      shortName: menhirVoucher.beneficiary.short_name,
      fullName: menhirVoucher.beneficiary.full_name,
      taxId: menhirVoucher.beneficiary.tax_id && {
        type: menhirVoucher.beneficiary.tax_id.type,
        value: menhirVoucher.beneficiary.tax_id.value,
      },
    },
    source: menhirVoucher.source,
  };
};

export const transformVouchersList = (
  menhirVouchers: IMenhirVoucher[]
): IVoucher[] => menhirVouchers.map(transformVoucher);

export const transformVoucherBalance = (
  menhirVoucherBalance: IMenhirVoucherBalance
): IVoucherBalance => ({
  totalAmount: menhirVoucherBalance.total_amount,
  details: menhirVoucherBalance.details.map((item) => ({
    quantity: item.quantity,
    type: item.type,
    amount: item.amount,
  })),
});
